(() => {
  if (window.ArDrBogoSignalsLoaded) return;
  window.ArDrBogoSignalsLoaded = true;

  const eligibleFormSelector =
    '[data-arista-bogo-eligible="true"] form[data-type="add-to-cart-form"]';
  const propertyName = 'properties[_arista_bogo_eligible]';

  const markForm = (form) => {
    if (form.querySelector(`input[name="${propertyName}"]`)) return;

    const eligibilityInput = document.createElement('input');
    eligibilityInput.type = 'hidden';
    eligibilityInput.name = propertyName;
    eligibilityInput.value = 'true';
    form.appendChild(eligibilityInput);
  };

  const syncEligibleForms = (root = document) => {
    if (root instanceof Element && root.matches(eligibleFormSelector)) markForm(root);
    root.querySelectorAll?.(eligibleFormSelector).forEach(markForm);
  };

  const initialiseGiftProperties = (root = document) => {
    root.querySelectorAll?.('[data-arista-gift-toggle]').forEach((toggle) => {
      if (toggle.dataset.aristaGiftReady === 'true') return;
      toggle.dataset.aristaGiftReady = 'true';
      const panel = toggle.closest('.arista-gift-property')?.querySelector('[data-arista-gift-message]');
      const message = panel?.querySelector('textarea[name="properties[Gift message]"]');
      const sync = () => {
        if (!panel) return;
        panel.hidden = !toggle.checked;
        toggle.setAttribute('aria-expanded', String(toggle.checked));
        if (!toggle.checked && message) message.value = '';
      };
      toggle.addEventListener('change', sync);
      sync();
    });
  };

  const initialisePersonalization = (root = document) => {
    root.querySelectorAll?.('[data-arista-personalization-required]').forEach((wrapper) => {
      wrapper.querySelectorAll('input[name="properties[Choose an alphabet charm]"]').forEach((input) => {
        if (input.dataset.aristaPersonalizationReady === 'true') return;
        input.dataset.aristaPersonalizationReady = 'true';
        input.addEventListener('change', () => {
          const error = wrapper.querySelector('[data-arista-personalization-error]');
          if (error) error.hidden = true;
        });
      });
    });
  };

  const syncProductProperties = (root = document) => {
    initialiseGiftProperties(root);
    initialisePersonalization(root);
  };

  const start = () => {
    syncEligibleForms();
    syncProductProperties();

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target instanceof HTMLFormElement ? event.target : null;
        const wrapper = form?.querySelector('[data-arista-personalization-required]');
        if (!wrapper) return;
        const selected = wrapper.querySelector('input[name="properties[Choose an alphabet charm]"]:checked');
        if (selected) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        const error = wrapper.querySelector('[data-arista-personalization-error]');
        if (error) error.hidden = false;
        wrapper.querySelector('input[name="properties[Choose an alphabet charm]"]')?.focus();
      },
      true
    );

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            syncEligibleForms(node);
            syncProductProperties(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    syncEligibleForms(event.target);
    syncProductProperties(event.target);
  });
})();
